<template>
  <div class="maininfo">
    <!-- <a v-if="ggw1picsrc"  :href="ggw1picsrc.url"> <img class="advimg" :src="`${IP_TEST}/uploads/${ggw1picsrc.picsrc}`" /></a> -->
    <TopNews></TopNews>
    <Banner></Banner>
    <router-link to="/inquery?inqtype=px" style="display:block;width:1300px;height:93px;margin-top:40px;background-image:url(/static/img/img/chauxnxin.png);"></router-link>
    <news-center></news-center>
    <!-- <Editpublish></Editpublish> -->
    <PersonRongyu></PersonRongyu>
    <EnvironmentService></EnvironmentService>
    <IntegratedService></IntegratedService>
    <LiveBlogroll></LiveBlogroll>
    <!-- <a v-if="ggw2picsrc" :href="ggw2picsrc.url"> <img  class="advimg" :src="`${IP_TEST}/uploads/${ggw2picsrc.picsrc}`" /></a> -->
    
    <!-- <a v-if="ggw4picsrc" :href="ggw3picsrc.url"> <img  class="advimg" :src="`${IP_TEST}/uploads/${ggw4picsrc.picsrc}`" /></a> -->
    <!-- <AnliInteraction></AnliInteraction> -->
  </div>
</template>
<script>
import Banner from './main/Banner.vue';
import Subject from './main/Subject.vue';
import IntegratedService from './main/IntegratedService.vue';
import EnvironmentService from './main/EnvironmentService.vue';
import Interaction from './main/Interaction.vue';
import Editpublish from './main/Editpublish.vue';
import AnliInteraction from './main/AnliInteraction.vue';
import LiveBlogroll from './main/LiveBlogroll.vue';
import TopNews from './main/TopNews.vue'
import {getAd } from '@/request/get'
import {IP_TEST } from '@/config'
import NewsCenter from './main/NewsCenter.vue';
import PersonRongyu from './main/PersonRongyu.vue'
const rate= window.outerWidth/1440;
export default {
  name: "Main",
  metaInfo: {
    title: '北京软数人才测评网',
    meta: [
      { name:'viewport', content:
      `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`}
    ]
  },
  components: {
    Banner,
    Subject,
    IntegratedService,
    EnvironmentService,
    Interaction,
    AnliInteraction,
    TopNews,
    Editpublish,
    NewsCenter,
    PersonRongyu,
    LiveBlogroll
},
  data() {
    return {
          ggw1picsrc:'',
    ggw2picsrc:'',
    ggw3picsrc:'',
    ggw4picsrc:'',
    IP_TEST,
    }
  },
  created(){
    this.getAd()
  },
  mounted() {

  },
  methods: {
    async getAd() {
      let result = await getAd();
      let result1 = result.data && result.data.filter(item => item.position == '首页广告1');
      // console.log(result)
      this.ggw1picsrc = result1.length>0&&result1[0];
      let result2 = result.data && result.data.filter(item => item.position == '首页广告2');
      this.ggw2picsrc = result2.length>0&&result2[0];
      let result3 = result.data && result.data.filter(item => item.position == '首页广告3');
      this.ggw3picsrc = result3.length>0&&result3[0];
    },
  }
};
</script>
<style scoped>
.maininfo{
  position: relative;
  width: 1300px;
  margin: auto ;
}
.advimg{
  text-align: center;
    display: block;
    width: 100%;
    max-width: 1300px;
    margin: 20px auto;
}
</style>
